import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { MailMessageService } from 'src/app/Service/MailMessage/MailMessage.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-MailMessageEdit',
  templateUrl: './MailMessageEdit.component.html',
  styleUrls: ['./MailMessageEdit.component.scss']
})
export class MailMessageEditComponent implements OnInit {
  EditRecord:Number

  constructor(
    private MailMessage_Service:MailMessageService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
    private route: ActivatedRoute
  ) { }
  ngOnInit() {
    this.EditMailMessage=new FormGroup({
      id :new FormControl(),
      Title:new FormControl(null,Validators.required),
      Dsc:new FormControl(null,Validators.required),
    })

    this.EditRecord = Number(this.route.snapshot.paramMap.get('id'))


    this.Nav_Service.CheckValidPage(44).subscribe(
      data=>{
        this.MailMessage_Service.GetSingle(this.EditRecord).subscribe(
          data=>{
            this.get_Form_Id().setValue(data.id)
            this.get_Form_Title().setValue(data.title)
            this.get_Form_Dsc().setValue(data.code)

          }
        )
      }
      ,error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )

  }

    //#region  Form Add

    EditMailMessage:FormGroup;

    get_Form_Id(){
      return this.EditMailMessage.get('id') as FormControl;
    }

    get_Form_Title(){
      return this.EditMailMessage.get('Title') as FormControl;
    }

    get_Form_Dsc(){
      return this.EditMailMessage.get('Dsc') as FormControl;
    }
    //#endregion

    InProccessing:boolean=false

    SubmitEditMailMessage(){
      var Record:General_Interface =Empty_General_Interface()
      Record.id=this.get_Form_Id().value
      Record.title=this.get_Form_Title().value
      Record.code=this.get_Form_Dsc().value
      this.InProccessing=true
      this.MailMessage_Service.EditMail_Message(Record).subscribe(
        data=>{
          this.InProccessing=false
          if(data.id==-2){
            this.Alertify_Service.ErrorMessage("عنوان وارد شده ، در لیست وجود دارد")
          }
          else{

            this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
          }
        }
      )
    }



}
